import { Trans } from '@lingui/react'
import type { FC } from 'react'

import Modal from 'views/components/molecules/Modal'
import { CREDIT_BALANCE_INFORMATION_MODAL } from 'views/components/organisms/CreditBalanceInformationModal/names'
import './CreditBalanceInformationModal.scss'

export const CreditBalanceInformationModal: FC<{ open?: boolean }> = ({
  open,
}) => (
  <Modal
    size="medium"
    id={CREDIT_BALANCE_INFORMATION_MODAL}
    title={<Trans id="general.label.credit.balance" />}
    isClientSideControlled
    needsDataQaId
    open={open}
  >
    <p className="o-CreditBalanceInformationModal-paragraph">
      <span className="o-CreditBalanceInformationModal-paragraph">
        <Trans
          id="cart.modal.credit.balance.first.paragraph"
          components={{ 0: <strong /> }}
        />
      </span>
    </p>
    <p className="o-CreditBalanceInformationModal-paragraph">
      <span className="o-CreditBalanceInformationModal-paragraph">
        <Trans
          id="cart.modal.credit.balance.second.paragraph"
          components={{ 0: <strong /> }}
        />
      </span>
    </p>
    <p className="o-CreditBalanceInformationModal-paragraph">
      <span className="o-CreditBalanceInformationModal-paragraph">
        <Trans id="cart.modal.credit.balance.third.paragraph" />
      </span>
    </p>
    <p className="o-CreditBalanceInformationModal-paragraph">
      <Trans
        id="cart.modal.credit.balance.fourth.paragraph"
        components={{ 0: <strong /> }}
      />
    </p>
  </Modal>
)
